import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, onMounted, nextTick } from "vue";
import { getTeamEvaluationClassResultsFragment } from "@/services/surveyResultsService";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import { evalOverviewGraph } from "@/scripts/faculty/eval-overview-viz.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamEvaluationClassResults',
  props: {
    cohortId: {},
    cohortSurveyId: {}
  },
  setup(__props: any) {

const props = __props;



const fragment = ref<string>();

onMounted(async () => {
  fragment.value = undefined;
  fragment.value = await getTeamEvaluationClassResultsFragment(
    props.cohortId,
    props.cohortSurveyId
  );
  nextTick(() => {
    evalOverviewGraph();
  });
});

return (_ctx: any,_cache: any) => {
  return (!fragment.value)
    ? (_openBlock(), _createBlock(LoadingIndicator, {
        key: 0,
        "loading-text": "Loading class results..."
      }))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "member-results",
        innerHTML: fragment.value
      }, null, 8, _hoisted_1))
}
}

})